// This component is for Second tab (Practice details) in Application form. //
To get practice place and experience details from attorney
<template>
  <div class="bg-gray-50 shadow px-4 py-5 sm:rounded sm:p-6" v-bind:class="{ 'model-open': showDeleteModal }">
    <div class="md:grid md:grid-cols-2 md:gap-6 sm:px-6">
      <div class="md:col-span-1">
        <h3 class="text-lg font-medium leading-6 text-gray-900">PRACTICE DETAILS</h3>
        <p class="mt-1 text-sm text-gray-500">Practice & License Details</p>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <form @submit.prevent="submitApplication" novalidate class="space-y-6">
          <div class="shadow sm:rounded-md sm:overflow-hidden">
            <div class="bg-white py-6 px-4 space-y-6 sm:p-6">
              <div class="grid grid-cols-6 gap-6">
                <div class="col-span-6 sm:col-span-2">
                  <!-- Undergrad College -->
                  <text-input label="Undergraduate College" :class="{ 'border-red-400': v$.form.college.$error }"
                    v-bind:value="form.college" id="college" :required="$route.name == 'UpdateProfile' ? false : true"
                    v-on:keyup="form.college = $event.target['value']"></text-input>
                  <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.college.$errors" :key="index">
                    <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-span-6 sm:col-span-2">
                  <!-- Law School -->
                  <text-input label="Law School" :required="$route.name == 'UpdateProfile' ? false : true"
                    :class="{ 'border-red-400': v$.form.low_school.$error }" v-bind:value="form.low_school"
                    id="low_school" v-on:keyup="form.low_school = $event.target['value']"></text-input>
                  <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.low_school.$errors"
                    :key="index">
                    <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-span-6 sm:col-span-2">
                  <!-- Law School -->
                  <text-input label="Normal Hourly Rate (US$)" :class="{
                    'border-red-400': v$.form.normal_hourly_rate.$error,
                  }" :required="true" type="number" v-bind:value="form.normal_hourly_rate" id="normal_hourly_rate"
                    v-on:keyup="
                      form.normal_hourly_rate = $event.target['value']
                      "></text-input>
                  <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.normal_hourly_rate.$errors"
                    :key="index">
                    <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-span-6 sm:col-span-2">
                  <text-input label="Number of Years in Practice" :required="$route.name == 'UpdateProfile' ? false : true"
                    :class="{
                      'border-red-400':
                        v$.form.number_of_year_in_practice.$error,
                    }" type="number" v-bind:value="form.number_of_year_in_practice" id="number_of_year_in_practice"
                    v-on:keyup="
                      form.number_of_year_in_practice = $event.target['value']
                      "></text-input>
                  <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.number_of_year_in_practice
                    .$errors" :key="index">
                    <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-span-6 sm:col-span-2">
                  <text-input label="Number of Attorneys in Firm" type="number"
                    :required="$route.name == 'UpdateProfile' ? false : true" :class="{
                      'border-red-400':
                        v$.form.number_of_attorney_in_firm.$error,
                    }" v-bind:value="form.number_of_attorney_in_firm" id="number_of_attorney_in_firm" v-on:keyup="
                      form.number_of_attorney_in_firm = $event.target['value']
                      "></text-input>
                  <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.number_of_attorney_in_firm
                    .$errors" :key="index">
                    <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-span-6 sm:col-span-2">
                  <label class="block text-sm font-medium text-gray-900">
                    Gender
                    <span v-if="$route.name != 'UpdateProfile'" class="text-red-500">*</span>
                  </label>
                  <label v-for="item in gender_options" :key="item.id" class="inline-flex items-center mt-3 ml-2">
                    <input type="radio" v-model="form.gender" :value="item.name"
                      class="form-radio h-5 w-5 cobalt-text-color" />
                    <span class="ml-2 text-black-100">{{ item.name }}</span>
                  </label>
                  <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.gender.$errors" :key="index">
                    <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-span-6 sm:col-span-2">
                  <label class="block text-sm font-medium text-gray-900">Business</label>
                  <AutoComplete class="h-10" forceSelection v-model="form.business" :dropdown="true"
                    :suggestions="business_options" @complete="searchAutocomplete($event, 'business')" field="name" />
                </div>
                <div class="col-span-6 sm:col-span-4">
                  <text-input
                    label="Do you have a Martindale-Hubbell or other professional rating? If so, please list it."
                    :class="{
                      'border-red-400': v$.form.professional_rating.$error,
                    }" v-bind:value="form.professional_rating" id="professional_rating" v-on:keyup="
                      form.professional_rating = $event.target['value']
                      "></text-input>
                  <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.professional_rating
                    .$errors" :key="index">
                    <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                  </div>
                </div>
                <!-- cdl -->
                <div class="col-span-6 sm:col-span-2">
                  <label class="block text-sm font-medium text-gray-900">Knowledge of FMSCA and DataQ
                    Challenges?</label>
                  <label v-for="item in flag_options" :key="item.id" class="inline-flex items-center mt-3 ml-2">
                    <input type="radio" :value="item.name" class="form-radio h-5 w-5 cobalt-text-color"
                      v-model="form.fmca_knw" />
                    <span class="ml-2 text-black-100">{{ item.name }}</span>
                  </label>
                </div>
                <div class="col-span-6 sm:col-span-2">
                  <label class="block text-sm font-medium text-gray-900" for="firstname">
                    Are you or your staff fluent in:
                    <span v-if="$route.name != 'UpdateProfile'" class="text-red-500">*</span>
                  </label>
                  <label v-for="(item, index) in language_options" :key="index"
                    class="inline-flex items-center mt-3 ml-2">
                    <input type="checkbox" :value="item" v-model="form.language_fluent"
                      class="focus:ring-indigo-500 h-6 w-6 cobalt-text-color border-gray-300 rounded" />
                    <span class="ml-2 text-gray-800">{{ item }}</span>
                  </label>
                  <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.language_fluent.$errors"
                    :key="index">
                    <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                  </div>
                </div>
                <div class="col-span-6 sm:col-span-2" v-if="form.language_fluent.includes('Others')">
                  <text-input label="Other languages? (Please list)" v-bind:value="form.other_languages"
                    id="other_languages" helptext="format => language1, language2"
                    v-on:keyup="form.other_languages = $event.target['value']"></text-input>
                </div>
                <div class="col-span-6 sm:col-span-2">
                  <label class="block text-sm font-medium text-gray-900" for="date_admitted_to_bar">Ethnicity</label>
                  <AutoComplete appendTo="body" class="h-10 pt-1" forceSelection :dropdown="true" readonly
                    v-model="form.ethnicity" :suggestions="ethnicity"
                    @complete="searchAutocomplete($event, 'ethnicity')" field="name" />
                </div>
              </div>
            </div>
          </div>
          <!-- START CREDENTIALS SECTION -->

          <div class="shadow sm:rounded-md sm:overflow-hidden 2">
            <div class="bg-white py-6 px-4 space-y-6 sm:p-6">
              <div class v-for="(credential, i) in form.credentials" :key="i">
                <div class="flex cobalt-bg-color items-center justify-between flex-wrap sm:flex-nowraps">
                  <div class="m-4">
                    <h3 class="text-lg leading-6 font-medium text-white">CREDENTIALS & INSURANCE</h3>
                    <p class="mt-1 text-sm text-white">
                      Please enter the states that you are licensed to practice
                      in.
                    </p>
                  </div>
                  <div class="mr-4 flex-shrink-0" v-if="i == 0">
                    <button type="button" @click="add_license()"
                      class="relative inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white barley-btn focus:outline-none focus:ring-2 focus:ring-offset-2">+
                      Add Credential</button>
                  </div>
                  <div class="mr-4 flex-shrink-0" v-if="i != 0">
                    <button type="button" @click="ConfirmLicenseDelete(i)"
                      class="relative inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-red-500 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">+
                      Remove Credential</button>
                  </div>
                </div>
                <div>
                  <div class="form-group grid grid-cols-6 gap-6 mt-2">
                    <div class="col-span-6 sm:col-span-1">
                      <label class="block text-sm font-medium text-gray-900 mb-1" for="type">
                        State
                        <span class="text-red-500">*</span>
                      </label>
                      <AutoComplete class="h-10" appendTo="body" forceSelection :dropdown="true"
                        v-model="credential.lic_state" :class="{
                          'border-red-400':
                            v$.form.credentials[i]?.lic_state.$error,
                        }" placeholder="Select States" :suggestions="state_list"
                        @complete="searchAutocomplete($event, 'state')" field="state_name" />
                      <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.credentials[i]
                        ?.lic_state.$errors" :key="index">
                        <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                      </div>
                    </div>
                    <div class="col-span-6 sm:col-span-1">
                      <text-input label="Bar Number" :required="true" v-model="credential.bar_number"
                        v-bind:value="credential.bar_number" :id="'bar_number' + i" :class="{
                          'border-red-400':
                            v$.form.credentials[i]?.bar_number.$error,
                        }" v-on:keyup="
                          credential.bar_number = $event.target['value']
                          "></text-input>
                      <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.credentials[i]
                        ?.bar_number.$errors" :key="index">
                        <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                      </div>
                    </div>
                    <div class="col-span-6 sm:col-span-2">
                      <text-input label="Professional Liability Insurance Company" :id="'insurance_company' + i"
                        :required="false" v-model="credential.insurance_company" :class="{
                          'border-red-400':
                            v$.form.credentials[i]?.insurance_company.$error,
                        }" v-bind:value="credential.insurance_company" v-on:keyup="
                          credential.insurance_company = $event.target['value']
                          "></text-input>
                      <!-- <div
                        class="text-red-600 mt-1 text-sm"
                        v-for="(error, index) in v$.form.credentials[i]
                          ?.insurance_company.$errors"
                        :key="index"
                      >
                        <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                      </div> -->
                    </div>
                    <div class="col-span-6 sm:col-span-2">
                      <text-input label="Insurance Policy Number" :id="'policy_number' + i"
                        v-model="credential.policy_number" :required="false" :class="{
                          'border-red-400':
                            v$.form.credentials[i]?.policy_number.$error,
                        }" v-bind:value="credential.policy_number" v-on:keyup="
                          credential.policy_number = $event.target['value']
                          "></text-input>
                      <!-- <div
                        class="text-red-600 mt-1 text-sm"
                        :required="true"
                        v-for="(error, index) in v$.form.credentials[i]
                          ?.policy_number.$errors"
                        :key="index"
                      >
                        <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                      </div> -->
                    </div>
                    <div class="col-span-6 sm:col-span-2">
                      <label class="block text-sm font-medium text-gray-900" for="date_admitted_to_bar">
                        Date Admitted to Bar
                        <span class="text-red-500">*</span>
                      </label>
                      <flat-pickr v-model="credential.date_admitted_to_bar" :config="config"
                        class="w-full text-black border-1 border-barley rounded py-2 px-4" :class="{
                          'border-red-400':
                            v$.form.credentials[i]?.date_admitted_to_bar.$error,
                        }" placeholder="Select date"></flat-pickr>
                      <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.credentials[i]
                        ?.date_admitted_to_bar.$errors" :key="index">
                        <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                      </div>
                    </div>
                    <div class="col-span-6 sm:col-span-2">
                      <label class="block text-sm font-medium text-gray-900" for="lic_issue_date">
                        Insurance Issue Date
                        <!-- <span class="text-red-500">*</span> -->
                      </label>
                      <flat-pickr v-model="credential.lic_issue_date" :config="config" :class="{
                        'border-red-400':
                          v$.form.credentials[i]?.lic_issue_date.$error,
                      }" @on-change="
                          expirationConfig.minDate = credential.lic_issue_date
                          " class="w-full text-black border-1 border-barley rounded py-2 px-4"
                        placeholder="Select date"></flat-pickr>
                      <!-- <div
                        class="text-red-600 mt-1 text-sm"
                        v-for="(error, index) in v$.form.credentials[i]
                          ?.lic_issue_date.$errors"
                        :key="index"
                      >
                        <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                      </div> -->
                    </div>
                    <div class="col-span-6 sm:col-span-2">
                      <label class="block text-sm font-medium text-gray-900" for="lic_exp_date">
                        Insurance Expiration Date
                        <!-- <span class="text-red-500">*</span> -->
                      </label>
                      <flat-pickr :class="{
                        'border-red-400':
                          v$.form.credentials[i]?.lic_exp_date.$error,
                      }" v-model="credential.lic_exp_date" :config="expirationConfig"
                        class="w-full text-black border-1 border-barley rounded py-2 px-4"
                        placeholder="Select date"></flat-pickr>
                      <!-- <div
                        class="text-red-600 mt-1 text-sm"
                        v-for="(error, index) in v$.form.credentials[i]
                          ?.lic_exp_date.$errors"
                        :key="index"
                      >
                        <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End Credentials Section -->
          <!-- Start File Upload Section -->
          <div class="shadow sm:rounded-md sm:overflow-hidden 2">
            <div class="bg-white py-6 px-4 space-y-6 sm:p-6">
              <div class>
                <div class="flex cobalt-bg-color items-center justify-between flex-wrap sm:flex-nowraps">
                  <div class="m-4">
                    <h3 class="text-lg leading-6 font-medium text-white">
                      <i class="fa fa-upload"></i> ATTORNEY FILES
                      <span class="text-red-500">*</span>
                    </h3>
                    <p class="mt-1 text-sm text-white">
                      Please attach a copy of the declaration page from your
                      professional liability policy and a copy of your W-9 Form.
                    </p>
                  </div>
                  <!-- <div class="mr-4 flex-shrink-0">
                    <button
                      type="button"
                      class="relative cursor-pointer inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white barley-btn focus:outline-none focus:ring-2 focus:ring-offset-2"
                    >
                      <input
                        class="file-input"
                        id="fileInput"
                        type="file"
                        name="files"
                        @change="uploadFile"
                      />
                      + Add File
                    </button>
                  </div> -->
                </div>
                <div>

                  <div class="form-group grid grid-cols-3 gap-3 m-2">
                    <!-- File Type Selection -->
                    <div class="col-span-6 sm:col-span-1">
                      <label for="fileType" class="block text-sm font-medium text-gray-700">
                        Select File Type <span class="text-red-500">*</span>
                      </label>
                      <select id="fileType"
                        class="form-select appearance-none block w-full px-3 py-2 text-base font-normal text-gray-700 bg-white border border-gray-300 rounded focus:border-blue-600 focus:outline-none"
                        v-model="fileType">
                        <!-- <option value="APP">Application (APP)</option> -->
                        <option value="DEC">DEC Page (DEC)</option>
                        <option value="W9">W9 (W9)</option>
                        <!-- <option value="FA">Fee Agreement (FA)</option> -->
                        <!-- <option value="DD">Direct Dep Info (DD)</option> -->
                        <!-- <option value="OTH">Other(OTH)</option> -->
                      </select>
                    </div>

                    <!-- File Input -->
                    <div class="col-span-6 sm:col-span-1">
                      <label for="fileInput" class="block text-sm font-medium text-gray-700">
                        Choose File <span class="text-red-500">*</span>
                      </label>
                      <input id="fileInput" type="file"
                        class="block w-full text-sm border border-gray-300 rounded mt-1 cursor-pointer"
                        accept=".pdf,application/pdf"
                        @change="handleFileChange" />
                      <!-- <p v-if="fileName" class="text-xs text-gray-600 mt-1">{{ fileName }}</p> -->
                    </div>

                    <!-- Upload Button -->
                    <div class="flex items-center justify-center col-span-6 sm:col-span-1">
                      <button type="button"
                        class="px-3 py-2 cobalt-bg-color text-white rounded shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2"
                        @click="uploadFile" :disabled="!file || !fileType">
                        Upload File
                      </button>
                    </div>
                  </div>

                </div>
                <div class="form-group grid grid-cols-3 gap-4 mt-2" v-if="form?.uploadedFiles?.length > 0">
                  <div class="col-span-6 sm:col-span-1" v-for="(file, i) in form.uploadedFiles" :key="i">
                    <div class="py-5 px-3" v-if="att_user?.data && att_user != undefined">
                      <a :href="MS_BASE +
                        '/tools/download_attachment.php?filename=' +
                        BASE_S3 +
                        '/' +
                        file.Key
                        " class="float-right">
                        <i class="fa fa-download cobalt-text-color"></i>
                      </a>
                      <a v-if="$route.name != 'UpdateProfile'" href="javascript:void(0);" @click="deleteFile(file)"
                        class="float-right mr-2">
                        <i class="fa fa-trash-o text-red-700"></i>
                      </a>
                      <div class="float-left mr-2" align="center">
                        <img src="@/assets/Images/file-pdf.png" />
                      </div>
                      <div class="float-left w-100">
                        <span class>{{ file.name }}</span>
                      </div>
                    </div>
                    <div class="py-5 px-3" v-if="!att_user?.data || att_user == undefined">
                      <a :href="API_BASE +
                        'downloadTempFile.php?name=' +
                        file.name +
                        '&attorney_number=' +
                        leadData?.result?.lead[0]?.id +
                        '&module=attorney'
                        " class="float-right">
                        <i class="fa fa-download cobalt-text-color"></i>
                      </a>
                      <a href="javascript:void(0);" @click="deleteFile(file)" class="float-right mr-2">
                        <i class="fa fa-trash-o text-red-700"></i>
                      </a>
                      <div class="float-left mr-2" align="center">
                        <img src="@/assets/Images/file-pdf.png" />
                      </div>
                      <div class="float-left w-100">
                        <span class>{{ file.name }}</span>
                      </div>
                    </div>
                    <br />
                    <hr />
                  </div>
                </div>
                <div class="text-center pt-5" v-if="form?.uploadedFiles?.length <= 0">
                  <span>No Files Found.</span>
                </div>
                <div class="text-red-600 text-sm ml-3" v-for="(error, index) in v$.form.uploadedFiles.$errors"
                  :key="index">
                  <div v-if="error.$validator == 'required'">Please upload files</div>
                </div>
              </div>
            </div>
          </div>
          <!-- End File Upload Section -->
        </form>
      </div>
    </div>
    <confirm-popup :showDeleteModal="showLicenseDeleteModal" title="Delete" short_msg="Are you sure?"
      msg=" Do you really want to delete this state? This process cannot be undone." @click="cancelModal()"
      @remove="remove_license()"></confirm-popup>
    <confirm-popup :showDeleteModal="showFileDeleteModal" title="Delete" short_msg="Are you sure?"
      msg=" Do you really want to delete this file? This process cannot be undone." @click="cancelModal()"
      @remove="remove_file()"></confirm-popup>
  </div>
</template>
<script>
import TextInput from "../Layout/Form/TextInput.vue"; // importing resuable input field
import ConfirmPopup from "../Layout/Modals/ConfirmPopup.vue"; // importing resuable delete modal
import useVuelidate from "@vuelidate/core"; // importing validation library
import { required } from "@vuelidate/validators"; // importing diffrene validation types from library.
import { mapState } from "vuex"; // importing mapState for get access state level variables.
import $ from "jquery"; // To use jquery
import Constants from "../../constants.ts"; // importing constant resubale variables.
// import moment from "moment-timezone";

export default {
  name: "AppPractice",
  setup() {
    return { v$: useVuelidate() }; //creating object to access validation object.
  },
  props: ["forms"], // To access variable passed from Parent component.
  data: function () {
    // declaring static variable for this component
    return {
      ethnicity: [
        { id: 0, name: "American Indian or Alaska Native" },
        { id: 1, name: "Asian" },
        { id: 2, name: "Black or African American" },
        { id: 3, name: "Hispanic or Latino" },
        { id: 4, name: "Native Hawaiian or Other Pacific Islander" },
        { id: 5, name: "White" },
        { id: 6, name: "Prefer not to answer" }
      ],
      form: this.forms,
      showLicenseDeleteModal: false,
      showFileDeleteModal: false,
      deleteLicenseIndex: "",
      deletefileIndex: null,
      errors: [],
      business_options: [],
      businessObj: [
        { id: 1, name: "Minority Owned" },
        { id: 2, name: "Female Owned" }
      ],
      state_list: [],
      flag_options: [
        { id: 1, name: "Yes" },
        { id: 0, name: "No" }
      ],
      MS_BASE: Constants.MS_BASE,
      BASE_S3: Constants.BASE_S3,
      API_BASE: Constants.API_BASE,
      gender_options: [
        { id: 0, name: "Male" },
        { id: 1, name: "Female" },
        { id: 2, name: "Other" },
        { id: 3, name: "Prefer Not To Answer" }
      ],
      language_options: ["English", "Spanish", "French", "Creole", "Others"],
      sizes: ["lg", "md", "sm"],
      config: {
        wrap: true,
        altFormat: "M j, Y",
        altInput: true,
        dateFormat: "Y-m-d"
      },
      expirationConfig: {
        wrap: true,
        altFormat: "M j, Y",
        altInput: true,
        dateFormat: "Y-m-d"
      },
      fileType: "DEC",
      file: null,
      fileName: "",
    };
  },
  // dynamic validations based on fields
  validations() {
    let credentials = [];
    for (let index = 0; index < this.form?.credentials?.length; index++) {
      if (index == 0) {
        credentials.push({
          lic_state: { required },
          bar_number: { required },
          insurance_company: {},
          policy_number: {},
          lic_issue_date: {},
          lic_exp_date: {},
          date_admitted_to_bar: { required }
        });
      } else {
        credentials.push({
          lic_state: {},
          bar_number: {},
          insurance_company: {},
          policy_number: {},
          lic_issue_date: {},
          lic_exp_date: {},
          date_admitted_to_bar: {}
        });
      }
    }
    if (this.$route.name == "UpdateProfile") {
      return {
        form: {
          college: {},
          uploadedFiles: {},
          low_school: {},
          number_of_year_in_practice: {},
          professional_rating: {},
          number_of_attorney_in_firm: {},
          normal_hourly_rate: { required },
          gender: {},
          language_fluent: {},
          credentials: credentials
        }
      };
    } else {
      return {
        form: {
          college: { required },
          uploadedFiles: { required },
          low_school: { required },
          number_of_year_in_practice: { required },
          professional_rating: {},
          number_of_attorney_in_firm: { required },
          normal_hourly_rate: { required },
          gender: { required },
          language_fluent: { required },
          credentials: credentials
        }
      };
    }
  },
  mounted() {
    (this.form.uploadedFiles = []),
      //calling method from store to get state list from API
      this.$store.dispatch("getState");
    // calling method to get uploaded files list of attorney
    setTimeout(() => {
      this.show_upload();
    }, 500);
  },
  // to Access central level variables from Store
  computed: mapState([
    "leadData",
    "stateList",
    "att_user",
    "profile_data",
    "tempAttData"
  ]),
  created() {
    // to contiues watch on get update changes of store variables.
    this.$store.watch(
      () => this.$store.state.attorney_files,
      value => {
        if (value != "") {
          this.listingUI(value);
        }
      }
    );
    this.$store.watch(
      () => this.$store.state.is_uploaded,
      value => {
        if (value == true) {
          this.$toast.success("File uploaded successfully");
          this.show_upload();
        }
      }
    );
    this.$store.watch(
      () => this.$store.state.profile_data,
      value => {
        if (value != null) {
          if (this.att_user?.data && this.att_user != undefined) {
            this.form.id = this.profile_data?.id;
            this.businessObj.forEach(element => {
              if (element.name == this.profile_data.business) {
                this.form.business = element;
              }
            });
            this.ethnicity.forEach(element => {
              if (element.name == this.profile_data?.ethnicity) {
                this.form.ethnicity = element;
              }
            });

            if (typeof this.profile_data.lang_spoken == "string") {
              this.form.language_fluent = [];
              this.form.first_name = this.profile_data?.first_name;
              this.form.college = this.profile_data.college;
              this.form.low_school = this.profile_data.low_school;
              this.form.normal_hourly_rate = this.profile_data.normal_hourly_rate;
              this.form.number_of_year_in_practice = this.profile_data.number_of_year_in_practice;
              this.form.number_of_attorney_in_firm = this.profile_data.number_of_attorney_in_firm;
              this.form.gender = this.profile_data.gender;
              this.form.professional_rating = this.profile_data.professional_rating;
              this.form.fmca_knw = this.profile_data.fmca_knw;

              //language
              this.profile_data.lang_spoken = JSON.parse(
                this.profile_data.lang_spoken
              );
              let other_languages = [];
              for (
                let index = 0;
                index < Object.keys(this.profile_data.lang_spoken.lang).length;
                index++
              ) {
                const element = this.profile_data.lang_spoken.lang[index];
                if (!this.language_options.includes(element)) {
                  if (element != undefined && element != "") {
                    if (!other_languages.includes(element)) {
                      other_languages.push(element);
                    }
                  }
                } else {
                  this.form.language_fluent.push(element);
                }
              }
              if (other_languages.length > 0) {
                this.form.language_fluent.push("Others");
                this.form.other_languages = other_languages.join(",");
              }
            }
            //credentials
            this.form.credentials = this.profile_data?.credentials;
            for (
              let index = 0;
              index < this.form?.credentials?.length;
              index++
            ) {
              this.stateList?.forEach(state => {
                if (state.STATECD == this.form.credentials[index].lic_state) {
                  console.log(state);
                  this.form.credentials[index].lic_state = state;
                }
              });
            }
          }
        }
      }
    );
    // if attorney logged in and submitted enrollment form.
    if (!this.att_user?.data || this.att_user == undefined) {
      if (!this.tempAttData.is_attorney_exist) {
        // filling details in form which comes from Lead API
        let Data = this.leadData.result.lead[0];
        let keys = Object.keys(Data);
        keys.forEach(key => {
          if (key.includes("gender_")) {
            if (Data[key] != "" && Data[key] != null) {
              this.gender_options.forEach(opt => {
                if (
                  opt.id == Data[key] ||
                  Data[key].toLowerCase() == opt.name.toLowerCase()
                ) {
                  this.form.gender = opt.name;
                }
              });
            }
          }
          if (key.includes("fluent_languages_")) {
            if (Data[key] != "" && Data[key] != null) {
              this.language_options.forEach(opt => {
                 if (
                  opt == Data[key] ||
                  Data[key].toLowerCase() == opt.toLowerCase()
                ) {
                  this.form.language_fluent.push(opt);
                }
              });
            }
          }
        });
      }
    }
  },
  // Importing resuable component to use in this component
  components: {
    TextInput,
    ConfirmPopup
  },
  methods: {
    //Confirmation modal for delete attorney file
    deleteFile: function (file) {
      this.showFileDeleteModal = true;
      this.deletefileIndex = file;
    },
    // get list of attorney files
    show_upload: function () {
      if (this.att_user?.data && this.att_user != undefined) {
        setTimeout(() => {
          this.$store.dispatch(
            "getFilesList",
            this.profile_data?.attorney_number
          );
        }, 1000);
      } else {
        this.$store.dispatch("getTempFilesList", {
          attorney_number: this.leadData.result.lead[0].id,
          module: "attorney"
        });
      }
    },
    listingUI: function (data) {
      this.form.uploadedFiles = data.data;
    },
    handleFileChange(event) {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        this.file = selectedFile;
        this.fileName = selectedFile.name;
      }
    },
    // upload attorney file
    uploadFile: function () {
      this.$store.dispatch("resetUploadFlag");
      var filename = $("#fileInput").val();
      if (filename.indexOf("\\") > -1) {
        filename = filename.split("\\").pop();
      }
      if (filename.substr(filename.length - 4) != ".pdf") {
        this.$toast.error("Only PDF allowed");
        return false;
      }
      for (let i = 0; i < this.form.uploadedFiles.length; i++) {
        if (this.form.uploadedFiles[i].name == filename) {
          this.$toast.error("Duplicate file can not be allowed.");
          return false;
        }
      }
      if (filename == "") {
        this.$toast.error("Please specify a file to import.");
        return false;
      }
      var file = $("#fileInput")[0].files[0];
      // console.log("🚀 ~ file:", file)
      // console.log("filetype", this.fileType);
      
      const formData = new FormData();
      // return;
      formData.append("file", file);
      formData.append("fileType", this.fileType);
      if (this.att_user?.data && this.att_user != undefined) {
        formData.append("attorney_number", this.att_user.data.attorney_number);
        this.$store.dispatch("uploadFile", formData);
      } else {
        formData.append("attorney_number", this.leadData.result.lead[0].id);
        formData.append("module", "attorney");
        this.$store.dispatch("uploadTempFile", formData);
      }
    },
    // submit and validate form
    submitApplication: function () {
      this.v$.form.$touch(this.v$.form.errors);
      if (this.v$.form.$pending || this.v$.form.$error) return;
      if (
        this.form["other_languages"] != null &&
        this.form["other_languages"] != undefined
      ) {
        var str_array = this.form["other_languages"].split(",");
        str_array.forEach(element => {
          this.form["language_fluent"].push(element.replace(/\s+/g, ""));
        });
      }
      var newLang = [{ lang: {} }];
      if (this.form["language_fluent"].length > 0) {
        let i = 0;
        this.form["language_fluent"].forEach(element => {
          if (element != "Others") {
            newLang[0]["lang"][i] = element.replace(/\s+/g, "");
            i++;
          }
        });
      }
      this.form["language"] = JSON.stringify(newLang[0]);
    },
    // filter dropdown list based on typed value
    searchAutocomplete: function (event, field) {
      if (field == "state") {
        console.log(1);
        if (!event.query.trim().length) {
          this.state_list = [...this.stateList];
        } else {
          this.state_list = this.stateList.filter(item => {
            return item.state_name
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
      } else if (field == "ethnicity") {
        if (!event.query.trim().length) {
          this.ethnicity = [...this.ethnicity];
        } else {
          this.ethnicity = this.ethnicity.filter(item => {
            return item.name
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
      } else if (field == "business") {
        console.log(1);
        if (!event.query.trim().length) {
          this.business_options = [...this.businessObj];
        } else {
          this.business_options = this.businessObj.filter(item => {
            return item.name
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
      }
    },
    // remove credential from credentials array
    remove_license: function () {
      this.form.credentials.splice(this.deleteLicenseIndex, 1);
    },
    // add credential
    add_license: function () {
      this.form.credentials.push({
        lic_state: "",
        bar_number: "",
        insurance_company: "",
        policy_number: "",
        lic_issue_date: "",
        lic_exp_date: "",
        lic_app_date: "",
        lic_app_exp_date: "",
        date_admitted_to_bar: ""
      });
    },
    // remove file from uplaoded files
    remove_file: function () {
      if (this.att_user?.data && this.att_user != undefined) {
        this.$store.dispatch("deleteFile", { file: this.deletefileIndex }).then(
          response => {
            console.log(response);
            setTimeout(() => {
              if (this.$store.state.errors.length <= 0) {
                this.$toast.success("File deleted successfully");
                this.show_upload();
              }
            }, 1000);
          },
          error => {
            console.error("error from response", error);
          }
        );
      } else {
        this.$store
          .dispatch("deleteTempFile", { file: this.deletefileIndex })
          .then(
            response => {
              console.log(response);
              setTimeout(() => {
                if (this.$store.state.errors.length <= 0) {
                  this.$toast.success("File deleted successfully");
                  this.show_upload();
                }
              }, 1000);
            },
            error => {
              console.error("error from response", error);
            }
          );
      }
    },
    // On cancel delete modal
    cancelModal: function () {
      this.showLicenseDeleteModal = false;
      this.showFileDeleteModal = false;
    },
    // Confirmation modaal to delete credential
    ConfirmLicenseDelete: function (index) {
      this.showLicenseDeleteModal = true;
      this.deleteLicenseIndex = index;
    }
  }
};
</script>
